import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import PropTypes from "prop-types";
import APPCONFIG from "constants/Config";
import ObjectOverride from "components/ObjectOverride";
import {confirmAlert} from "react-confirm-alert";
import API from "@beardeddevops/react.api";
import {Button} from "reactstrap";

/**
 *  @property {Customers_Identifications_Object} state
 *  @property {object} model
 *  @property {Customers_Identifications_Properties} model.properties
 *  @property {Customers_Identifications_Is} model.is
 *  @property {Customers_Identifications_Has} model.has
 */
class CustomerIdentification extends ObjectOverride {
	static propTypes = {
		...super.PropTypes,
		identification: PropTypes.object,
	};

	constructor(props) {
		super(props, Types.Customers_Identifications._name);
	}

	// noinspection JSUnusedGlobalSymbols
	loadSelf = async () => {
		let data = this.props.identification;
		if (this._ismounted && data) {
			this.model.properties.forEach((item, key) => {
				if (typeof item !== 'undefined' && item && typeof data[key] !== 'undefined') {
					this.setState({[key]: data[key]});
				}
			});
			this.model.has.forEach((item, key) => {
				if (typeof item !== 'undefined' && item && typeof data[key] !== 'undefined') {
					this.setState({[key]: data[key]});
				}
			});
			this.model.is.forEach((item, key) => {
				if (typeof item !== 'undefined' && item && typeof data[key] !== 'undefined') {
					this.setState({[key]: data[key]});
				}
			});
			await this.setState({
				"loading": false,
				"loaded": true
			});
			// noinspection JSPotentiallyInvalidUsageOfClassThis
			this.loadSelfAfter(data);
		}

		this.loadSelfAfterAlways();
	};

	handleSubmit = async () => {
		//TODO: make this property not required. It looks like it is checking a string value of null which is causing an error for validating date format
		// since it is neither null nor a string in date format; but a string containing "null"
		if( !this.props.rootState.hasTwinCityPawnModule && (this.state.identification_expiration === null || this.state.identification_expiration === '') ) {
			this.state.identification_expiration = "2099-12-31 23:59:59"
		}

		if( this.props.rootState.hasTwinCityPawnModule && (this.state.identification_expiration === '' || this.state.identification_expiration === null) ) {
			this.setState({identification_expiration_error: "Identification Expiration is Required"})
		}
		else {
			await super.handleSubmit();
		}
	}

	removeIdentificationImage = async (img_param) => {
		if(this.state[img_param].includes('identification')) {
			this.model.request = 'POST_IMAGE_REMOVE';
			if (img_param === 'image') {
				this.model.object.image = this.state.image;
				this.setState({ image: null });
				this.state.image = null;
				if (typeof(this.props.afterSave) === 'function') {
					this.props.afterSave(this.state);
				}
			} else {
				this.model.object.image_back = this.state.image_back;
				this.setState({ image_back: null });
				this.state.image_back = null;
				if (typeof(this.props.afterSave) === 'function') {
					this.props.afterSave(this.state);
				}
			}
			try {
				await this.model.submit(null, 'POST_IMAGE_REMOVE');
			} catch (e) {

			}
		}
		else {
			this.setState({[img_param]: ''});
		}
	}

	handleDeleteImage = (image) => {
		confirmAlert({
			title: 'Confirm Delete',
			message: typeof this.delete_message !== 'undefined' ? this.delete_message : 'Are you sure you want to remove this image?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						try {
							this.removeIdentificationImage(image)
						} catch (error) {
						}
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	form = () => {
		/** @type {Customers_Identifications_Properties} properties */
		let properties = this.model.properties;
		/** @type {Customers_Identifications_Object} object */
		let object = this.state;
		let {loading} = this.state;
		return (
			<div>
				<fieldset>
					<h4 className="section-title">4473 Identification
					</h4>
					<div className="form-group">
						<Framework.Elements.TextField
							property={properties.identification_authority}
							value={object.identification_authority}
							error={object.identification_authority_error}
							update={this.handleTextFieldPropertyUpdate}
							label={"Authority"}
						/>
					</div>
					<div className="form-group">
						<Framework.Elements.TextField
							property={properties.identification_type}
							value={object.identification_type}
							error={object.identification_type_error}
							update={this.handleTextFieldPropertyUpdate}
							label={"Type"}
						/>
					</div>
					<div className="form-group">
						<Framework.Elements.TextField
							property={properties.identification_number}
							value={object.identification_number}
							error={object.identification_number_error}
							update={this.handleTextFieldPropertyUpdate}
							label={"Number"}
						/>
					</div>
					<div className="form-group">
						<Framework.Elements.Date
							label={"Issue Date"}
							property={properties.identification_issue}
							value={object.identification_issue}
							error={object.identification_issue_error}
							update={this.handleTextFieldPropertyUpdate}
						/>
					</div>
					<div className="form-group">
						<Framework.Elements.Date
							label={"Expiration Date"}
							property={properties.identification_expiration}
							value={object.identification_expiration}
							error={object.identification_expiration_error}
							update={this.handleTextFieldPropertyUpdate}
						/>
					</div>
					<div className="form-group">
						<Framework.Elements.TextField
							property={properties.alternate_documentation}
							value={object.alternate_documentation}
							error={object.alternate_documentation_error}
							update={this.handleTextFieldPropertyUpdate}
							label={"Alternate Documentation"}
						/>
					</div>
					<div className="form-group">
						<Framework.Elements.TextField
							property={properties.non_immigrant_visa_prohibition}
							value={object.non_immigrant_visa_prohibition}
							error={object.non_immigrant_visa_prohibition_error}
							update={this.handleTextFieldPropertyUpdate}
							label={"Nonimmigrant Visa Prohibition"}
						/>
					</div>
					{/*#region Front Image Upload*/}
					<h4 className="section-title">Identification Image Upload</h4>
					<div className={"form-group"}>
						<h6>Upload a copy of the identification for future reference and verification. Files must be .png, .jpg, or .jpeg. Max file size is 4MB. <b>After you finish uploading, click Save.</b></h6>
						<p>Image Front</p>
						<Framework.Elements.DropZone
							property={properties.image}
							value={object.image}
							error={object.image_error}
							update={this.handleFileChange}
							label={'Drag \'n\' drop front image here, or click to select image'}
						/>
						<br/>
						{object.image && <div>
							<p style={{display: "inline"}}>Current Front Image</p>
							<Button className="image_remove_button" color="warning" onClick={() => this.handleDeleteImage('image')}>Remove Image</Button>
							<img
								src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/customers/' + object.customer_binary_id + '-' + object.customer + '/identifications/' + object.binary_id + '-' + object.pkey + '/images?image=' + object.image}
								alt={object.image}
								className='image_upload_images'
							/>
							{object.image ?
								<span>Current Image - <b>{object.image}</b></span>
								: null}
						</div>}
						<br/>
						<p>Image Back</p>
						<Framework.Elements.DropZone
							property={properties.image_back}
							value={object.image_back}
							error={object.image_back_error}
							update={this.handleFileChange}
							label={'Drag \'n\' drop back image here, or click to select image'}
						/>
						<br/>
						{object.image_back && <div>
							<p style={{display: "inline"}}>Current Back Image</p>
							<Button className="image_remove_button" color="warning" onClick={() => this.handleDeleteImage('image_back')}>Remove Image</Button>
							<img
								src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/customers/' + object.customer_binary_id + '-' + object.customer + '/identifications/' + object.binary_id + '-' + object.pkey + '/images/back?image=' + object.image_back}
								alt={object.image_back}
								className='image_upload_images'
							/>
							{object.image_back ?
								<span>Current Image - <b>{object.image_back}</b></span>
								: null}
						</div>}
					</div>
					{/*#endregion*/}
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};
}


export default Framework.Components.withRootState(CustomerIdentification);